import { css } from 'lit';

export const dlStyles = css`
  dl {
    margin: 0;
    padding: 0;
  }

  @media (min-width: 500px) {
    dl {
      display: flex;
      gap: var(--s-spacer);
      flex-wrap: wrap;
    }
  }

  dl > div {
    flex: 1 0 auto;
    max-width: 100%;
    display: block;
    position: relative;
  }

  dt {
    font-size: 14px;
    color: #6b6b6b;
  }

  dd {
    font-size: var(--s-spacer);
    line-height: 32px;
    margin: 0;
    padding: 0;
  }

  dd ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  dd a {
    color: var(--uui-color-text);
  }
  dd a[href]:hover {
    color: var(--uui-color-default);
  }
`;
